import * as i0 from '@angular/core';
import { Injectable, Inject, Component, Input, NgModule } from '@angular/core';
import { get } from 'lodash-es';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

class TcmImageService {
    constructor(tridionBaseUrl) {
        this.tridionBaseUrl = tridionBaseUrl;
    }
    getImageUrl(link) {
        const imagePath = get(link, 'Fields.EmbeddedValues.0.HightResolutionIMage.LinkedComponentValues.0.Multimedia.Url', '') ||
            get(link, 'Fields.EmbeddedValues.0.Image.LinkedComponentValues.0.Multimedia.Url', '') ||
            get(link, 'Fields.Image.LinkedComponentValues.0.Multimedia.Url', '') ||
            get(link, 'Fields.LinkedComponentValues.0.Multimedia.Url', '') ||
            get(link, 'Fields.NavThumbnail.LinkedComponentValues.0.Multimedia.Url', '') ||
            get(link, 'Multimedia.Url', '') ||
            get(link, 'Fields.Multimedia.Url', '') ||
            get(link, 'Fields.Url', '');
        return `${this.tridionBaseUrl}${imagePath}`;
    }
    getImageAltText(link) {
        return (get(link, 'Fields.AltText.Values.0', '') ||
            get(link, 'Fields.Image.LinkedComponentValues.0.MetadataFields.alt.Values.0', '') ||
            get(link, 'Multimedia.AltText', '') ||
            get(link, 'Fields.Image.LinkedComponentValues.0.Multimedia.AltText', '') ||
            get(link, 'Fields.EmbeddedValues.0.AltText.Values.0', '') ||
            get(link, 'Fields.EmbeddedValues.0.HightResolutionIMage.LinkedComponentValues.0.Multimedia.AltText', '') ||
            get(link, 'Fields.EmbeddedValues.0.Image.LinkedComponentValues.0.Multimedia.AltText', '') ||
            get(link, 'Fields.LinkedComponentValues.0.Multimedia.AltText', '') ||
            get(link, 'Fields.AltText', '') ||
            get(link, 'Fields.EmbeddedValues.0.HightResolutionIMage.LinkedComponentValues.0.MetadataFields.alt.Values.0', '') ||
            get(link, 'Fields.MetadataFields.alt.Values.0', '') ||
            get(link, 'Fields.EmbeddedValues.0.Image.LinkedComponentValues.0.MetadataFields.alt.Values.0', '') ||
            get(link, 'Fields.LinkedComponentValues.0.MetadataFields.alt.Values.0', '') ||
            get(link, 'MetadataFields.alt.Values.0', ''));
    }
    getImageTitleText(link) {
        return (get(link, 'Fields.EmbeddedValues.0.ImageTitle.Values.0') ||
            get(link, 'Fields.Image.LinkedComponentValues.0.Title') ||
            get(link, 'Fields.Image.LinkedComponentValues.0.MetadataFields.title.Values.0', '') ||
            get(link, 'Fields.EmbeddedValues.0.HightResolutionIMage.LinkedComponentValues.0.MetadataFields.title.Values.0') ||
            get(link, 'Fields.EmbeddedValues.0.Image.LinkedComponentValues.0.MetadataFields.title.Values.0') ||
            get(link, 'Fields.LinkedComponentValues.0.MetadataFields.title.Values.0'));
    }
}
TcmImageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmImageService, deps: [{ token: 'TridionBaseUrl' }], target: i0.ɵɵFactoryTarget.Injectable });
TcmImageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmImageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmImageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['TridionBaseUrl']
                }] }]; } });

class TcmImageComponent {
    constructor(imgService) {
        this.imgService = imgService;
    }
    ngOnChanges(changes) {
        if (changes.data) {
            this.data = changes.data.currentValue;
            this.setUrls();
        }
    }
    setUrls() {
        this.url = this.imgService.getImageUrl(this.data);
        this.altText = this.imgService.getImageAltText(this.data);
        this.titleText = this.imgService.getImageTitleText(this.data);
        if (this.width) {
            this.url = `${this.url}?imwidth=${this.width}`;
        }
    }
}
TcmImageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmImageComponent, deps: [{ token: TcmImageService }], target: i0.ɵɵFactoryTarget.Component });
TcmImageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: TcmImageComponent, selector: "tcm-image", inputs: { data: "data", width: "width" }, usesOnChanges: true, ngImport: i0, template: "<img *ngIf=\"url\" src=\"{{ url }}\" title=\"{{ titleText }}\" alt=\"{{ altText }}\" />\r\n", styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}img{max-width:100%;height:auto}:host-context(.hero-full-size-image) img{width:100%}\n"], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmImageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tcm-image', template: "<img *ngIf=\"url\" src=\"{{ url }}\" title=\"{{ titleText }}\" alt=\"{{ altText }}\" />\r\n", styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}img{max-width:100%;height:auto}:host-context(.hero-full-size-image) img{width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: TcmImageService }]; }, propDecorators: { data: [{
                type: Input
            }], width: [{
                type: Input
            }] } });

class TcmImageModule {
}
TcmImageModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmImageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TcmImageModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmImageModule, declarations: [TcmImageComponent], imports: [CommonModule], exports: [TcmImageComponent] });
TcmImageModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmImageModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TcmImageModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [TcmImageComponent],
                    exports: [TcmImageComponent]
                }]
        }] });

export { TcmImageComponent, TcmImageModule, TcmImageService };
